import React, { useEffect, useLayoutEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Box,
    Switch,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Typography,
    Tabs,
    Tab,
    TextField,
    Popper,
    ClickAwayListener,
    Paper,
    Chip,
    InputAdornment,
    Tooltip,
    Autocomplete,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import { Clear } from "@mui/icons-material";
import { errorToast } from "../../helpers";
import Pagination from "../../components/Pagination";
import Loader from "../../helpers/constants/Loader";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import { useLazyGetAllTypeOfCompaniesQuery } from "../../services/users";
import { AUTO_XML_TYPE, LISTING_TYPE, ROLE, XML_PROPERTY_TYPE } from "../../constants/enums";
import { useLazyGetXmlPropertiesQuery, useLazyGetXmlRecordsDetailsQuery } from "../../services/property";
import { useLazyGetAllActionTrackerForXmlQuery } from "../../services/actionTracker";



interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const Overview = () => {
    const navigate = useNavigate();
    const { id, recordId } = useParams();
    const [rows, setRows] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [getAllProperties] = useLazyGetXmlRecordsDetailsQuery();
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    let totalPages = Math.ceil(totalCount / limit);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [dataCount, setDataCount] = useState<any>({
        newlyAddedProperties: 0,
        xmlDeletedProperties: 0,
        previouslyPublishedProperties: 0,
        listingActionTrackerProperties: 0

    })

    const onPageChange = (newPage: number) => {
        setPage(newPage);
        setRows([]);
    };
    const { state } = useLocation();
    const [value, setValue] = React.useState(0);
    console.log(value, "value");


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        setPage(1);
    };

    const [valueInnerTab, setValueInnerTab] = React.useState(0);

    // const handleChangeForInnerTab = (event: React.SyntheticEvent, newValue: number) => {
    //     setValueInnerTab(newValue);
    //     setPage(1);
    // };

    const [open1, setOpen1] = useState(false); // Control calendar visibility
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [selectedChip, setSelectedChip] = useState("");
    const [month, setMonth] = useState(new Date());
    const [listingActionTracker] = useLazyGetAllActionTrackerForXmlQuery();
    const [range, setRange] = useState<{
        from: Date | undefined;
        to: Date | undefined;
    }>({
        from: undefined,
        to: undefined,
    });

    const handleClose = () => {
        setOpen1(false);
    };


    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen1(true);
    };

    function formatNumberWithCommas(value: string | number) {
        const valueStr = typeof value === 'number' ? value.toFixed(2) : value;
        const [integer, decimal] = valueStr.split('.');
        const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        let result = decimal !== undefined ? `${formattedInteger}.${decimal}` : formattedInteger;
        return result;
    }

    const getFormattedRange = () => {
        if (range?.from && range?.to) {
            return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
                range.to
            ).format("MM/DD/YYYY")}`;
        } else if (range?.from) {
            return moment(range.from).format("MM/DD/YYYY");
        }
        return "";
    };

    const handleSelect = (selectedRange: any) => {
        if (selectedRange === undefined) {
            setRange({ from: undefined, to: undefined });
        } else {
            setRange(selectedRange);
        }
    };

    const handleChipClick = (value: any) => {
        if (value === selectedChip) {
            setSelectedChip("");
            setRange({ from: undefined, to: undefined });
            setMonth(moment().toDate());
            return;
        }
        setSelectedChip(value);

        let newRange = { from: moment().toDate(), to: moment().toDate() };
        const today = moment();

        if (value === "lastMonth") {
            newRange = {
                from: moment().subtract(1, "months").startOf("month").toDate(),
                to: moment().subtract(1, "months").endOf("month").toDate(),
            };
        } else if (value === "lastWeek") {
            newRange = {
                from: moment().subtract(7, "days").startOf("day").toDate(),
                to: today.toDate(),
            };
        } else if (value === "lastYear") {
            newRange = {
                from: moment().subtract(1, "years").startOf("year").toDate(),
                to: moment().subtract(1, "years").endOf("year").toDate(),
            };
        }
        setRange(newRange);
        setMonth(newRange.from);
    };

    const handleMonthChange = (newMonth: any) => {
        setMonth(newMonth);
    };




    const getRequest = async () => {
        setIsLoading(true)
        try {
            const res = await getAllProperties({
                page: page,
                limit: limit,
                startDate: range?.from ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
                endDate: range?.from === range?.to ? "" : range?.to ? moment(range?.to).utc().format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
                search: debouncedSearchTerm?.trim(),
                id: id,
                autoXmlType: value === 0 ? AUTO_XML_TYPE.PREVIOUSLY_PUBLISHED : value === 1 ? AUTO_XML_TYPE.NEWLY_ADDED : value === 2 ? AUTO_XML_TYPE.XML_DELETED : AUTO_XML_TYPE.LISTING_ACTION_TRACKER,
            }).unwrap();
            if (res?.statusCode === 200) {
                setRows(res?.data?.autoXmlPerRecord?.rows || [])
                setTotalCount(res?.data?.autoXmlPerRecord?.count)
                setDataCount({
                    newlyAddedProperties: res?.data?.newlyAddedProperties || 0,
                    xmlDeletedProperties: res?.data?.xmlDeletedProperties || 0,
                    previouslyPublishedProperties: res?.data?.previouslyPublishedProperties || 0,
                    listingActionTrackerProperties: res?.data?.listingActionTrackerProperties || 0

                })
            }
            setIsLoading(false)
        } catch (error: any) {
            setIsLoading(false)
            errorToast(error?.data?.message)
        }
    }


    useLayoutEffect(() => {
        if (state?.tab) {
            setValue(state?.tab);
        }
    }, []);


    useEffect(() => {

        getRequest();

    }, [value, page, limit, debouncedSearchTerm, range])


    return (
        <div>
            <Loader isLoad={isLoading} />
            <div className="main_loyout">
                <div className="dashboard">
                    <h1 className="mn_hdng">Properties</h1>
                    <Button className="btn btn_primary" onClick={() => navigate(`/xml-overview-records/${recordId}`, { replace: true })} >Back</Button>
                </div>
                <Card className="cards">
                    <Box className="cards_header">
                        <Box className="cards_header_left">
                            <SearchBar2
                                value={searchTerm}
                                searchTerm={searchTerm}
                                onCross={() => setSearchTerm("")}
                                setDebouncedSearchTerm={setDebouncedSearchTerm}
                                onChange={(val: any) => {
                                    if (isValidInput(val.target.value)) {
                                        setSearchTerm(val.target.value);
                                        setTimeout(() => {
                                            setPage(1)
                                        }, 1000)
                                    }
                                }}
                            />
                            <div className="control_group" style={{ width: "250px" }}>
                                <TextField
                                    // label="Select Date Range"
                                    variant="outlined"
                                    hiddenLabel
                                    className="text_field-range"
                                    fullWidth
                                    onClick={handleClick}
                                    value={getFormattedRange()}
                                    placeholder="Select Date Range"
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: range?.from ? (
                                            <InputAdornment
                                                position="end"
                                                style={{ marginLeft: -50 }}
                                            >
                                                <IconButton
                                                    onClick={() => {
                                                        setRange({
                                                            from: undefined,
                                                            to: undefined,
                                                        });
                                                    }}
                                                >
                                                    <Clear />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <Popper
                                open={open1}
                                anchorEl={anchorEl}
                                placement="bottom-start"
                                disablePortal
                                style={{
                                    position: "relative",
                                    zIndex: 1,
                                }}
                            >
                                <ClickAwayListener onClickAway={handleClose}>
                                    <Paper
                                        elevation={3}
                                        style={{ position: "relative", zIndex: 1 }}
                                    >
                                        <div
                                            style={{
                                                padding: 16,
                                                borderRadius: 10,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-around",
                                                }}
                                            >
                                                <Chip
                                                    label="Last Week"
                                                    variant={
                                                        selectedChip === "lastWeek" ? "filled" : "outlined"
                                                    }
                                                    onClick={() => handleChipClick("lastWeek")}
                                                />
                                                <Chip
                                                    label="Last Month"
                                                    variant={
                                                        selectedChip === "lastMonth" ? "filled" : "outlined"
                                                    }
                                                    onClick={() => handleChipClick("lastMonth")}
                                                />
                                                <Chip
                                                    label="Last Year"
                                                    variant={
                                                        selectedChip === "lastYear" ? "filled" : "outlined"
                                                    }
                                                    onClick={() => handleChipClick("lastYear")}
                                                />
                                            </div>

                                            <DayPicker
                                                className="react-day-picker"
                                                mode="range"
                                                selected={range}
                                                onSelect={handleSelect}
                                                // numberOfMonths={10}
                                                month={month}
                                                onMonthChange={handleMonthChange}
                                            // styles={{
                                            //   months: { display: "flex", gap: "16px" },
                                            //   month: { margin: 0 },
                                            // }}
                                            />
                                        </div>
                                    </Paper>
                                </ClickAwayListener>
                            </Popper>

                        </Box>

                    </Box>
                    <Box className="custom_tabs">
                        <Tabs
                            style={{ marginTop: "20px" }}
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="basic tabs example"
                            className="custom_tabs_links"
                        >

                            <Tab
                                label={`Previous Properties (${dataCount?.previouslyPublishedProperties}) `}
                                {...a11yProps(0)}
                            />
                            <Tab
                                label={`Newly Added Properties (${dataCount?.newlyAddedProperties}) `}
                                {...a11yProps(1)}
                            />
                            <Tab
                                label={`Deleted Properties (${dataCount?.xmlDeletedProperties})`}
                                {...a11yProps(2)}
                            />
                            <Tab
                                label={`Listing Action Tracker Properties (${dataCount?.listingActionTrackerProperties})`}
                                {...a11yProps(3)}
                            />

                        </Tabs>
                        <div >

                            <TableContainer className="table_container">
                                <Box className="heading"></Box>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">S.No</TableCell>
                                            {/* <TableCell align="center">Actions</TableCell> */}
                                            <TableCell>Property Id</TableCell>
                                            <TableCell>Reference No.</TableCell>
                                            <TableCell>Badges</TableCell>
                                            <TableCell>Image</TableCell>
                                            <TableCell>Property Name</TableCell>
                                            <TableCell>Quality Score</TableCell>
                                            <TableCell>Price</TableCell>
                                            <TableCell>Company Name</TableCell>
                                            <TableCell>Agent Name</TableCell>
                                            <TableCell>Listing Type</TableCell>
                                            <TableCell>Boost Property</TableCell>
                                            <TableCell>Property Category</TableCell>
                                            <TableCell>Property Type</TableCell>
                                            <TableCell>Expiry Date</TableCell>
                                            <TableCell>Date & time</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.length == 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={9} align="center">
                                                    No Property found
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            rows?.map((row: any, i: any) => (
                                                <TableRow key={row?.i}>
                                                    <TableCell align="center">
                                                        {(page - 1) * 10 + i + 1}
                                                    </TableCell>
                                                    {/* <TableCell align="center">
                                                        <Box className="table_actions">

                                                            <Tooltip title="View Property details">
                                                                <IconButton
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/manage-xml-properties-details/${value === 4 ? row?.properties?._id : row?._id}`,
                                                                            { state: { tab: value, innerTab: valueInnerTab } }
                                                                        )
                                                                    }
                                                                >
                                                                    <VisibilityIcon />
                                                                </IconButton>
                                                            </Tooltip>


                                                        </Box>
                                                    </TableCell> */}
                                                    <TableCell>{row?.properties?.referenceId || "-"}</TableCell>
                                                    <TableCell>{row?.properties?.import_reference_number || "-"}</TableCell>
                                                    <TableCell align="center">
                                                        <figure
                                                            className="user_img"
                                                        >

                                                            {row?.properties?.isVerified ? (
                                                                <img className="property_badge" src="/static/images/verfy_icon.svg" alt="" />
                                                            ) : ("")}
                                                            {row?.properties?.qualityScore >= 80 ? (
                                                                <img src="/static/images/verify_ico.svg" alt="" />
                                                            ) : ("")}
                                                            {row?.properties?.isPropertyBoost ? (
                                                                <img src="/static/images/boost.png" alt="" />
                                                            ) : ("")}

                                                        </figure>
                                                    </TableCell>
                                                    <TableCell>
                                                        <figure

                                                            className="user_img"

                                                        >
                                                            <img
                                                                style={{ borderRadius: 0 }}
                                                                src={
                                                                    row?.properties?.images?.[0] ? row?.properties?.images?.[0] : row?.properties?.interior?.[0] ? row?.properties?.interior?.[0] :
                                                                        `/static/images/product1.png`
                                                                }

                                                                alt=""
                                                            />


                                                        </figure>
                                                    </TableCell>
                                                    <TableCell style={{ minWidth: "220px", textWrap: "wrap" }} >{row?.properties?.name || "-"}</TableCell>
                                                    <TableCell> {row?.properties?.qualityScore || "-"}</TableCell>
                                                    <TableCell>
                                                        {row?.properties?.price
                                                            ? formatNumberWithCommas(String(row?.properties?.price))
                                                            : "-"}
                                                    </TableCell>
                                                    <TableCell>{row?.properties?.companyId?.companyName ? row?.properties?.companyId?.companyName + " (" + row?.properties?.companyId?.referenceId + ")" : "-"}</TableCell>
                                                    <TableCell>{row?.properties?.agentId?.role === 5 || !row?.properties?.agentId?.role ? "-" : row?.properties?.agentId?.name + " (" + row?.properties?.agentId?.referenceId + ")"}</TableCell>
                                                    <TableCell>
                                                        {row?.properties?.listingType
                                                            ?
                                                            LISTING_TYPE[row?.properties?.listingType] : "-"}
                                                    </TableCell>
                                                    <TableCell>
                                                        {row?.properties?.isPropertyBoost
                                                            ? "Yes"
                                                            : "No"}
                                                    </TableCell>
                                                    <TableCell>{row?.properties?.categoryId?.name || "-"}</TableCell>
                                                    <TableCell>
                                                        {row?.properties?.propertyTypeId?.name || "-"}
                                                    </TableCell>
                                                    <TableCell>{row?.properties?.propertyEndDate ? moment(row?.properties?.propertyEndDate).format("LLL") : "-"}</TableCell>

                                                    <TableCell>{row?.properties?.createdAt ? moment(row?.properties?.createdAt).format("LLL") : "-"}</TableCell>

                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {rows?.length > 0 ? (
                                <Pagination
                                    setPage={setPage}
                                    limit={limit}
                                    setLimit={setLimit}
                                    module={rows}
                                    page={page}
                                    onPageChange={onPageChange}
                                    totalPages={totalPages}
                                />
                            ) : (
                                ""
                            )}

                        </div>

                    </Box>

                </Card>
            </div>
        </div>
    );
};

export default Overview;


